import buildAsyncCall from './asyncCall'
import * as Helpers from './helpers'

const Types = {
    DASHBOARD_LIFTANDLEARN_DWELLTIME: {
        request: 'DASHBOARD_LIFTANDLEARN_DWELLTIME##REQUEST',
        success: 'DASHBOARD_LIFTANDLEARN_DWELLTIME##SUCCESS',
        failure: 'DASHBOARD_LIFTANDLEARN_DWELLTIME##FAILURE',
    },
    DASHBOARD_LIFTANDLEARN_DWELLTIMELINE: {
        request: 'DASHBOARD_LIFTANDLEARN_DWELLTIMELINE##REQUEST',
        success: 'DASHBOARD_LIFTANDLEARN_DWELLTIMELINE##SUCCESS',
        failure: 'DASHBOARD_LIFTANDLEARN_DWELLTIMELINE##FAILURE',
    },
    DASHBOARD_LIFTANDLEARN_DWELLTIMELINE_PRODUCT: {
        request: 'DASHBOARD_LIFTANDLEARN_DWELLTIMELINE_PRODUCT##REQUEST',
        success: 'DASHBOARD_LIFTANDLEARN_DWELLTIMELINE_PRODUCT##SUCCESS',
        failure: 'DASHBOARD_LIFTANDLEARN_DWELLTIMELINE_PRODUCT##FAILURE',
    },
    DASHBOARD_LIFTANDLEARN_DWELLTIME_AVERAGE: {
        request: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_AVERAGE##REQUEST',
        success: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_AVERAGE##SUCCESS',
        failure: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_AVERAGE##FAILURE',
    },
    DASHBOARD_LIFTANDLEARN_DWELLTIME_BOUNCERATE: {
        request: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_BOUNCERATE##REQUEST',
        success: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_BOUNCERATE##SUCCESS',
        failure: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_BOUNCERATE##FAILURE',
    },
    DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL: {
        request: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL##REQUEST',
        success: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL##SUCCESS',
        failure: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL##FAILURE',
    },
    DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL_PRODUCT: {
        request: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL_PRODUCT##REQUEST',
        success: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL_PRODUCT##SUCCESS',
        failure: 'DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL_PRODUCT##FAILURE',
    },
    DASHBOARD_LIFTANDLEARN_TOP_PRODUCTS: {
        request: 'DASHBOARD_LIFTANDLEARN_TOP_PRODUCTS##REQUEST',
        success: 'DASHBOARD_LIFTANDLEARN_TOP_PRODUCTS##SUCCESS',
        failure: 'DASHBOARD_LIFTANDLEARN_TOP_PRODUCTS##FAILURE',
    },
    DASHBOARD_LIFTANDLEARN_TOP_STORES: {
        request: 'DASHBOARD_LIFTANDLEARN_TOP_STORES##REQUEST',
        success: 'DASHBOARD_LIFTANDLEARN_TOP_STORES##SUCCESS',
        failure: 'DASHBOARD_LIFTANDLEARN_TOP_STORES##FAILURE',
    },
    DASHBOARD_LIFTANDLEARN_TOTALINTERACTIONS: {
        request: 'DASHBOARD_LIFTANDLEARN_TOTALINTERACTIONS##REQUEST',
        success: 'DASHBOARD_LIFTANDLEARN_TOTALINTERACTIONS##SUCCESS',
        failure: 'DASHBOARD_LIFTANDLEARN_TOTALINTERACTIONS##FAILURE',
    },
}

function fetchLiftAndLearnDwellTime(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('liftandlearn/dwelltime', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE.request,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE.success,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE.failure,
        ],
    })
}

function fetchLiftAndLearnDwellTimeline(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('liftandlearn/dwelltime/timeline', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE.request,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE.success,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE.failure,
        ],
    })
}

function fetchLiftAndLearnDwellTimelineProduct(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('liftandlearn/dwelltime/timeline/products', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE_PRODUCT.request,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE_PRODUCT.success,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIMELINE_PRODUCT.failure,
        ],
    })
}

function fetchLiftAndLearnDwellTimeAverage(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('liftandlearn/dwelltime', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_AVERAGE.request,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_AVERAGE.success,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_AVERAGE.failure,
        ],
    })
}

function fetchLiftAndLearnDwellTimeBounceRate(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('liftandlearn/dwelltime/bounce', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_BOUNCERATE.request,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_BOUNCERATE.success,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_BOUNCERATE.failure,
        ],
    })
}

function fetchLiftAndLearnDwellTimeTotal(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('liftandlearn/dwelltime/total', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL.request,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL.success,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL.failure,
        ],
    })
}

function fetchLiftAndLearnDwellTimeTotalProduct(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('liftandlearn/dwelltime/total/products', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL_PRODUCT.request,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL_PRODUCT.success,
            Types.DASHBOARD_LIFTANDLEARN_DWELLTIME_TOTAL_PRODUCT.failure,
        ],
    })
}

function fetchLiftAndLearnTopStores(from, to) {
    return async (dispatch) => {
        const mainFetch = await dispatch(
            buildAsyncCall({
                endpoint: Helpers.buildUrl('liftandlearn/stores/top?count=4', from, to),
                method: 'GET',
                types: [
                    Types.DASHBOARD_LIFTANDLEARN_TOP_STORES.request,
                    Types.DASHBOARD_LIFTANDLEARN_TOP_STORES.success,
                    Types.DASHBOARD_LIFTANDLEARN_TOP_STORES.failure,
                ],
            })
        )
        const { type, payload } = mainFetch

        if (type !== Types.DASHBOARD_LIFTANDLEARN_TOP_STORES.success) {
            return mainFetch
        }

        const promises = await Promise.all(payload.map(({ store_code: storeCode }) => dispatch(Helpers.fetchStore(storeCode))))

        return [mainFetch, ...promises]
    }
}

function fetchLiftAndLearnTopProducts(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('liftandlearn/products/top?count=4', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_LIFTANDLEARN_TOP_PRODUCTS.request,
            Types.DASHBOARD_LIFTANDLEARN_TOP_PRODUCTS.success,
            Types.DASHBOARD_LIFTANDLEARN_TOP_PRODUCTS.failure,
        ],
    })
}

function fetchLiftAndLearnTotalInteractions(from, to) {
    return buildAsyncCall({
        endpoint: Helpers.buildUrl('liftandlearn/interactions', from, to),
        method: 'GET',
        types: [
            Types.DASHBOARD_LIFTANDLEARN_TOTALINTERACTIONS.request,
            Types.DASHBOARD_LIFTANDLEARN_TOTALINTERACTIONS.success,
            Types.DASHBOARD_LIFTANDLEARN_TOTALINTERACTIONS.failure,
        ],
    })
}

export {
    Types,
    fetchLiftAndLearnDwellTime,
    fetchLiftAndLearnDwellTimeline,
    fetchLiftAndLearnDwellTimelineProduct,
    fetchLiftAndLearnDwellTimeAverage,
    fetchLiftAndLearnDwellTimeBounceRate,
    fetchLiftAndLearnDwellTimeTotal,
    fetchLiftAndLearnDwellTimeTotalProduct,
    fetchLiftAndLearnTopProducts,
    fetchLiftAndLearnTopStores,
    fetchLiftAndLearnTotalInteractions,
}
